import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_hostel_category,
  add_hostel_category,
  update_hostel_category,
  delete_hostel_category,
  get_hostel_category_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    hostelcategory: [],
    hostelcategorylist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:""
  },
};

// Async Thunks for API Calls
export const fetchhostelcategorylist = createAsyncThunk(
    'hostelcategory/fetchhostelcategorylist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_hostel_category_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchhostelcategory = createAsyncThunk(
  "hostelcategory/fetchhostelcategory",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_hostel_category(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createhostelcategory = createAsyncThunk(
  "hostelcategory/createhostelcategory",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_hostel_category(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatehostelcategory = createAsyncThunk(
  "hostelcategory/updatehostelcategory",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_hostel_category(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletehostelcategory = createAsyncThunk(
  "hostelcategory/deletehostelcategory",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_hostel_category({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const hostelcategorySlice = createSlice({
  name: 'hostelcategorys',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:""
      };
    },
    setHostelCategory(state, action) {
      state.hostelcategory = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchhostelcategorylist.fulfilled, (state, action) => {
        state.hostelcategorylist = action.payload.data;
      })
       // Fetch hostel_category
       .addCase(fetchhostelcategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchhostelcategory.fulfilled, (state, action) => {
        state.loading = false;
        state.hostelcategory = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchhostelcategory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createhostelcategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createhostelcategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.hostelcategory = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createhostelcategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updatehostelcategory.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatehostelcategory.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatehostelcategory.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deletehostelcategory.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletehostelcategory.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletehostelcategory.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setHostelCategory,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = hostelcategorySlice.actions;
export default hostelcategorySlice.reducer;
